import Card from "./Card.svelte"
import Controls from "./Controls.svelte"
import Gallery from "./Gallery.svelte"

export default Object.assign(Gallery, { Card, Controls })
